import {array, bool, mixed, number, object, string} from "yup";

export const EmptySubmitter = {
    key: 0,
    name: "",
    email: "",
    phone: "",
    invoice: {
        name: "",
        address: {
            street: "",
            postalCode: "",
            city: "",
        },
        nip: "",
    },
};

export const EmptyLeadSubmitter = {
    name: "",
    email: "",
    phone: "",
};

export const EmptyForm = {
    candidate: {
        name: "",
        url: "",
        orgSize: "",
        member: "",
    },
    submitters: [EmptySubmitter],
    leadSubmitter: null,
    agreements: {
        notifyAboutCompetition: false,
        notifyAboutOtherActivities: false,
        termsAndConditions: false,
    },
    logo: {
        vector: null, // cdr, eps, ai, psd
        raster: null, // png, jpeg
    },
    submissions: [],
};

export const EmptySubmission = {
    key: -1,
    category: "",
    title: "",
    description: "",
    presentation: null, // pdf
};

export const Categories = [
    [
        "Kategorie dla podmiotów e-commerce",
        "Design & Usability",
        "Best campaign",
        "Best in omnichannel",
        "Breaking the doubts",
        "Best on mobile",
        "Best in crossborder",
        "Think out of the box",
        "Best in B2B e-commerce",
        "Best e-commerce retailer",
        "Best in CSR",
        "Best adaptation to new digital reality",
        "Best start in e-commerce (TYLKO PODMIOTY MAŁE)"
    ],
    [
        "Kategorie e-usługi",
        "Best tool for e-commerce",
        "Best marketing tool",
        "Best logistic tool",
        "Best e-commerce technology",
        "Best automatization tool/technology in e-commerce"
    ],
    ["Kategorie finansowe", "Best e-banking implementation", "Best on-line insurer", "Innovative e-payment solution"],
];

const strip = (c) => c.indexOf("(") >= 0 ? c.substring(0, c.indexOf("(")) : c

export const FormSchema = object().shape({
    candidate: object()
        .shape({
            name: string().required(),
            // company: string().required(),
            url: string().required(),
            orgSize: string().required().oneOf(["mały", "średni-duży"]),
            member: string().required().oneOf(["tak", "nie"]),
        })
        .required(),
    submitters: array()
        .of(
            object()
                .shape({
                    name: string().required(),
                    email: string().required().email(),
                    phone: string().required(),
                    invoice: object()
                        .shape({
                            name: string().required(),
                            address: object().shape({
                                street: string().required(),
                                postalCode: string()
                                    .required()
                                    .matches(/^\d{2}-\d{3}$/),
                                city: string().required(),
                            }),
                            nip: string()
                                .required()
                                .matches(/^\d{10}|(\d{3}-\d{3}-\d{2}-\d{2})|(\d{3}-\d{2}-\d{2}-\d{3})$/),
                        })
                        .required(),
                })
                .required()
        )
        .required()
        .min(1)
        .max(3),
    leadSubmitter: object().nullable().shape({
        name: string().required(),
        email: string().required().email(),
        phone: string().required(),
    }),
    agreements: object()
        .shape({
            notifyAboutCompetition: bool().required().oneOf([true]),
            notifyAboutOtherActivities: bool(),
            termsAndConditions: bool().required().oneOf([true]),
        })
        .required(),
    logo: object()
        .shape({
            vector: mixed().required(), // todo:
            // raster: mixed().required(), // todo:
        })
        .required(),
    submissions: array()
        .of(
            object().shape({
                key: number().required(),
                category: string()
                    .required()
                    .oneOf(Categories.reduce((a, i) => [...a, ...i.map(c => strip(c))], [])),
                title: string().required(),
                description: string().required().min(10).max(1000),
                presentation: mixed().required(), // todo:
            })
        )
        .required()
        .min(1)
        .max(3),
});
